module.exports = __webpack_public_path__ + "img/male.3fc3fe5d.png";